import { makeAutoObservable } from "mobx";
import {
    CAP_PRICE_DIFF_CALC_BY,
    ICapDiscountSetting
} from "../models/User";
import { IChangeable } from "./types";

interface ICapDiscountSettingChanges extends Partial<ICapDiscountSetting> {
};

class CapDiscountStore implements IChangeable<ICapDiscountSettingChanges>{
    private _model: ICapDiscountSetting = {} as ICapDiscountSetting;
    private _changes: ICapDiscountSettingChanges = {};

    constructor(capDiscountSetting: ICapDiscountSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this.setModel(capDiscountSetting);
    }

    private setModel(model: ICapDiscountSetting) {
        if (model) {
            this._model = model;
        }
        this.discardChanges();
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): ICapDiscountSetting {
        return { ...this._model, ...this._changes };
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public get productExchangePriceDiffCalcBy(): CAP_PRICE_DIFF_CALC_BY {
        return this._changes.product_exchange_price_diff_calc_by ?? this._model.product_exchange_price_diff_calc_by;
    }

    public get variantExchangePriceDiffCalcBy(): CAP_PRICE_DIFF_CALC_BY {
        return this._changes.variant_exchange_price_diff_calc_by ?? this._model.variant_exchange_price_diff_calc_by;
    }

    private _clearChangesIfEqual(key: keyof ICapDiscountSetting): void {
        if (this._changes[key] === this._model?.[key]) {
            delete this._changes[key];
        }
    }

    public setProductExchangePriceDiffCalcBy(value: CAP_PRICE_DIFF_CALC_BY) {
        this._changes.product_exchange_price_diff_calc_by = value;
        this._clearChangesIfEqual('product_exchange_price_diff_calc_by');
    }

    public setVariantExchangePriceDiffCalcBy(value: CAP_PRICE_DIFF_CALC_BY) {
        this._changes.variant_exchange_price_diff_calc_by = value;
        this._clearChangesIfEqual('variant_exchange_price_diff_calc_by');
    }
}

export default CapDiscountStore;
